<template>
	<!--START - Money Withdraw Form-->
	<div class="element-wrapper px-5 mt-5">
		<div class="element-box">
			<form v-if="accounts">
				<h5 class="element-box-header">
					{{ t.navigation.withdraw_money }}
				</h5>
				<div class="row">
					<div class="col-12">
						<div class="alert alert-danger" v-for="(v,k) in errors" v-if="errors">
							<strong><i class="os-icon os-icon-cancel-circle"></i></strong> {{ t.accounting.withdraw.error[k] }}
						</div>
					</div>
					<div class="col-6">
						<div class="form-group">
							<label for="">{{ t.accounting.label.select_amount }}</label>
							<div class="input-group mb-2 mr-sm-2 mb-sm-0">
								<input class="form-control" v-model="amount" type="number" min="0.00" max="10000.00" step="0.01">
								<div class="input-group-append">
									<div class="input-group-text">
										{{ session.currency.iso_code }}
									</div>
								</div>
							</div>
							<div class="text-danger mt-2">
								{{ t.limitations.type.daily_min_withdraw_money }}:
								<span class="pull-right">
									{{ minLimit | toMoney(session.currency) }}
								</span>
							</div>
						</div>
					</div>
					<div class="col-6">
						<div class="form-group">
							<label for="">{{ t.accounting.label.transfer_to }}</label>

							<v-select v-model="bank" label="name" :options="accounts" on-search="fetchBankAccounts"></v-select>
						</div>
					</div>
				</div>
				<div class="form-buttons-w text-right compact">
					<router-link class="btn btn-grey" :to="{ name: 'bank_account_create'}">
						<i class="os-icon os-icon-ui-22"></i><span>{{ t.bank_account.create_bank_account }}</span>
					</router-link>
					<a class="btn btn-primary" href="javascript:;" v-on:click="transferTo"><span>Transfer</span><i class="os-icon os-icon-grid-18"></i></a>
				</div>
			</form>
		</div>
	</div>
	<!--END - Money Withdraw Form-->
</template>

<script>
    import vSelect from "vue-select"
    import symForm from '@/components/form/symForm.vue'

    export default {
        name: 'withdraw',
	    components: {vSelect},
        data () {
            return {
                t: this.$root.t,
                session: this.$root.session,
	            bank: null,
	            amount: 0,
	            minLimit: 0,
                limitations: [],
	            accounts: [],
	            errors: null
            }
        },
	    mounted () {
            this.fetchLimitations();
            this.fetchBankAccounts();
	    },
	    methods: {
            transferTo () {

                this.$http.post(api+'api/v1/user/transaction/withdraw', {
                    amount: this.amount, bankId: this.bank.data.id
                })
                    .then(response => {

                        this.$bus.$emit('globalLoader', 0);
                        swal('', this.t.processing.success, "success");
                        setTimeout(window.location.reload(), 3000);
                    }, response => {

                        this.errors = response.body.error;
                        this.$bus.$emit('globalLoader', 0);
                    })
            },
            fetchBankAccounts () {
                this.$bus.$emit('globalLoader', 1);

                this.$http.get(api+'api/v1/user/accounting/bankAccounts/'+this.session.uid, {
                    params: { page: this.$route.query.page }
                })
                    .then(response => {

                        var th = this;
                        var accounts = response.body.result.accounts;

                        accounts.forEach(function(element) {
                            th.accounts.push({data: element, name: element.bankName +'  / '+element.identifier.substr(1, 6)+'*' })
                        });

                        this.$bus.$emit('globalLoader', 0);
                    }, response => {



                        this.$bus.$emit('globalLoader', 0);
                    })
            },
            fetchLimitations () {
                this.$http.get(api+'api/v1/limitations')
                    .then(response => {

						var th = this;

                        this.limitations = response.body.result.limitations;

                        this.limitations.finance.limits.forEach(function(element) {
                            if (element.key == 'daily_min_withdraw_money')
                            {
                                th.minLimit = element.limit;
                            }
                        });

                    }, response => {

                    })
            }
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/transactions/withdraw.vue